module.exports = __webpack_public_path__ + "img/two.458298df.gif";